export default {"src":"/spot-fe-premarket/_next/static/media/6.baba4e55.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};